import React, { useEffect, useState } from 'react';
import GridComponent from '../gridComponent';
import { ColorRing } from 'react-loader-spinner';
import { AlertCircle } from 'lucide-react/dist/cjs/lucide-react';

const HigherLevelData = ({
  isCsr,
  id,
  showLoading,
  higherLevelData,
  higherLevelClarityDatas,
  higherLevelColorKeys,
  allHigherLevelClarityRanges,
  defaultTurn,
  isHigherLevelLoading,
  isChangingGrading,
  setIsChangingGrading,
  minLoadingTimer,
  hoveredCell,
  handleCellHover,
  handleCellClick,
}) => {
  // const [hoveredCell, setHoveredCell] = useState(null);

  function roundIfFloat(value) {
    if (typeof value === 'number' && value % 1 !== 0) {
      return Math.round(value * 100) / 100;
    }
    return value;
  }

  useEffect(() => {
    if (higherLevelData?.data && isChangingGrading) {
      if (id !=="higherlevel"){
      setIsChangingGrading(false);
    }
    }
  }, [higherLevelData, isChangingGrading]);

  // const handleCellHover = (column, row) => {
  //   setHoveredCell(column !== null && row !== null ? { column, row } : null);
  // };

  // Show loading while higherLevelData is loading or undefined
  if (isChangingGrading || isHigherLevelLoading || !higherLevelData || minLoadingTimer) {
    return (
      <div className="flex justify-center items-center h-20">
        <ColorRing
          visible={true}
          height="60"
          width="60"
          ariaLabel="blocks-loading"
          colors={['#00319f', '#2e56b1', '#5c7bc2', '#8aa1d3', '#b2c1e2']}
        />
      </div>
    );
  }

  // Show "no data" message if higherLevelData has no meaningful content
  if (!higherLevelData?.data || higherLevelData.data.length === 0) {
    return (
    <div className="flex flex-col items-center justify-center text-center mt-12 text-gray-500">
      <AlertCircle className="w-10 h-10 mb-2 text-gray-400" />
      <p className="text-xl font-medium">Market Information not available.</p>
    </div>
    );
  }
else{
  
}
  return (
          <div className="bg-transparent px-5 flex justify-center items-center max-[1280px]:flex-col  gap-3">
              <GridComponent
                title="Average Rank"
                data={higherLevelData}
                min={0}
                max={100}
                hoveredCell={hoveredCell}
                onCellHover={handleCellHover}
                colorKeys={higherLevelColorKeys}
                allClarityRanges={allHigherLevelClarityRanges}
                clarityDatas={higherLevelClarityDatas}
                metric="rank_distribution"
                roundIfFloat={roundIfFloat}
                handleCellClick={handleCellClick}
              />
              <GridComponent
                title="Rank Movement"
                data={higherLevelData}
                min={-10}
                max={10}
                hoveredCell={hoveredCell}
                onCellHover={handleCellHover}
                colorKeys={higherLevelColorKeys}
                allClarityRanges={allHigherLevelClarityRanges}
                clarityDatas={higherLevelClarityDatas}
                metric="rank_movement"
                roundIfFloat={roundIfFloat}
                handleCellClick={handleCellClick}
              />
          </div>
  );
};

export default HigherLevelData;
